<template>
  <form class="form-base">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Номер счета"
            outlined
            v-model="$v.accountNumber.$model"
            v-mask="['####################']"
            :error-messages="getValidationErrorText($v.accountNumber)"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="$v.corrAccountNumber.$model"
            :errorMessages="getValidationErrorText($v.corrAccountNumber)"
            v-mask="['####################']"
            outlined
            label="Номер корреспондентского счета"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="$v.bic.$model"
            v-mask="['#########']"
            :errorMessages="getValidationErrorText($v.bic)"
            outlined
            label="БИК"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="$v.bankName.$model"
            :errorMessages="getValidationErrorText($v.bankName)"
            outlined
            label="Наименование банка получателя"
          />
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import { EMOJI, getValidationErrorText, MinLength } from '@/utils/validate';
import { isNotEmptyObjectCheck } from '@/utils/common';

export default {
  name: 'AccountDetailsForm',
  data: () => ({
    getValidationErrorText,
    accountNumber: '123123123123',
    corrAccountNumber: '42442224422424242',
    bic: '23423432423442324',
    bankName: 'ПАО Сбербанк',
  }),
  validations() {
    return {
      accountNumber: {
        minLength: minLength(20),
      },
      corrAccountNumber: {
        required,
        minLength: minLength(20),
      },
      bic: {
        required,
        minLength: minLength(MinLength.BIC),
      },
      bankName: {
        required,
        maxLength: maxLength(255),
        EMOJI,
      },
    };
  },
  props: {
    bankDetails: {
      type: Object,
    },
  },
  async created() {
    await this.reset();
    if (isNotEmptyObjectCheck(this.bankDetails)) {
      this.accountNumber = this.bankDetails.accountNumber;
      this.corrAccountNumber = this.bankDetails.corrAccountNumber;
      this.bic = this.bankDetails.bic;
      this.bankName = this.bankDetails.bankName;
    }
  },
  methods: {
    async reset() {
      this.accountNumber = '';
      this.corrAccountNumber = '';
      this.bic = '';
      this.bankName = '';
    },

    async upload() {
      this.$v.$touch();

      if ((this.accountNumber || this.corrAccountNumber) && !this.$v.$invalid) {
        const data = {
          accountNumber: this.accountNumber,
          corrAccountNumber: this.corrAccountNumber,
          bic: this.bic,
          bankName: this.bankName,
        };
        if (isNotEmptyObjectCheck(this.bankDetails)) {
          return {
            ...data,
            id: this.bankDetails.id,
          };
        }
        return {
          accountNumber: this.accountNumber,
          corrAccountNumber: this.corrAccountNumber,
          bic: this.bic,
          bankName: this.bankName,
        };
      }
      return null;
    },
  },
};
</script>

<style scoped lang="ts"></style>
